import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...props}><path d="M16.6 5.8A4.3 4.3 0 0 1 15.5 3h-3.1v12.4a2.6 2.6 0 1 1-2.6-2.6c.3 0 .5 0 .8.1V9.7a5.7 5.7 0 1 0 4.9 5.7V9.1a7.3 7.3 0 0 0 4.3 1.4V7.4a4.3 4.3 0 0 1-3.2-1.6z" /></svg>
);
const SOCIALS = [["facebook_url", Facebook, "facebook"], ["instagram_url", Instagram, "instagram"], ["x_url", Twitter, "x"], ["youtube_url", Youtube, "youtube"], ["tiktok_url", TikTok, "tiktok"]];
export const assetUrl = (u) => (u?.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const Brand = ({ site, dark, className = "" }) => {
  const logo = dark ? site?.logo_url : site?.logo_light_url || site?.logo_url;
  const name = site?.site_name || "All Sports Venues";
  if (logo) return <img src={assetUrl(logo)} alt={name} className={`h-8 w-auto max-w-[180px] object-contain ${className}`} data-testid="asv-brand-logo" />;
  const [first, ...rest] = name === "All Sports Venues" ? ["All Sports", "Venues"] : [name];
  return <span className={`asv-display font-extrabold leading-none ${className}`}>{first}{rest.length ? <> <span className="asv-accent">{rest.join(" ")}</span></> : null}</span>;
};

export const Footer = ({ site, dark }) => {
  const s = site || {};
  const socials = SOCIALS.filter(([k]) => s[k]);
  const [pages, setPages] = useState([]);
  useEffect(() => { api.get("/asv/pages").then((r) => setPages(r.data)).catch(() => {}); }, []);
  return (
    <footer className="mt-24 border-t asv-line" data-testid="asv-footer">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:grid-cols-2 sm:px-6 lg:grid-cols-4">
        <div className="space-y-3">
          <Brand site={s} dark={dark} className="text-lg" />
          <p className="asv-muted text-sm" data-testid="asv-footer-description">{s.short_description || "Find a court, an event or a game, and book it in one go."}</p>
          {!!socials.length && <div className="flex gap-2" data-testid="asv-footer-socials">{socials.map(([k, Icon, label]) => (
            <a key={k} href={s[k]} target="_blank" rel="noreferrer" aria-label={label} className="asv-btn-ghost !p-2" data-testid={`asv-social-${label}`}><Icon className="h-4 w-4" /></a>))}</div>}
        </div>
        <div className="flex flex-col gap-2 text-sm"><Link to="/venues">Venues</Link><Link to="/events">Events</Link><Link to="/games">Games</Link></div>
        <div className="flex flex-col gap-2 text-sm"><Link to="/join/user">Join as a player</Link><Link to="/join/vendor">List your venue</Link><Link to="/register-venue">Register your venue</Link></div>
        <div className="flex flex-col gap-2 text-sm" data-testid="asv-footer-contact">
          <Link to="/contact" data-testid="asv-footer-contact-link">Contact us</Link>
          {pages.map((p) => <Link key={p.slug} to={`/${p.slug}`} data-testid={`asv-footer-page-${p.slug}`}>{p.title}</Link>)}
        </div>
      </div>
      <div className="border-t asv-line px-4 py-5 text-center text-xs asv-muted" data-testid="asv-footer-copyright">
        {s.site_name || "All Sports Venues"} © {s.company_name || "Mhibus Soft Sdn Bhd"}
      </div>
    </footer>
  );
};
